import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '@core/service/base.service';

@Injectable({
  providedIn: 'root'
})
export class CompactModelService extends BaseService{

  private url = "api/compact-model";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }
}
